module.exports = __webpack_public_path__ + "static/index/img/baikal-306.5854ced7.jpg";